import { HistoryIcon, InsertChartOutlinedIcon } from '@shared/components';

export const iconMapper: Record<string, JSX.Element> = {
  REPORTS: <InsertChartOutlinedIcon />,
  LOGS: <HistoryIcon />,
};
